// extracted by mini-css-extract-plugin
export var deliveryRow = "_rx-a";
export var fixedHeight = "_rx-4";
export var freightLogo = "_rx-9";
export var fullWidth = "_rx-3";
export var priceColumn = "_rx-5";
export var radioSelected = "_rx-7";
export var radioUnselected = "_rx-6";
export var selectedOption = "_rx-2";
export var selectedOptionContainer = "_rx-1";
export var selection = "_rx-0";
export var tallSkeletonText = "_rx-8";